import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  FacebookAuthProvider,
  signInWithPopup,
} from "firebase/auth";

// Configuración de Firebase - REEMPLAZA CON TUS CREDENCIALES
const firebaseConfig = {
  apiKey: "AIzaSyAnfFzrH4pehSgdPKiw-SlOFd_X7qLq1IA",
  authDomain: "photo-8a7e2.firebaseapp.com",
  projectId: "photo-8a7e2",
  storageBucket: "photo-8a7e2.firebasestorage.app",
  messagingSenderId: "52493127446",
  appId: "1:52493127446:web:17f38a8d52057d19e8ca37",
  measurementId: "G-VRGP3WDQGM",
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Proveedores de autenticación
export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();

// Configurar proveedores
googleProvider.setCustomParameters({
  prompt: "select_account",
});

// Funciones de autenticación
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    return {
      success: true,
      user: {
        name: result.user.displayName,
        email: result.user.email,
        photo: result.user.photoURL,
        uid: result.user.uid,
      },
    };
  } catch (error) {
    console.error("Error con Google Sign In:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

export const signInWithFacebook = async () => {
  try {
    const result = await signInWithPopup(auth, facebookProvider);
    return {
      success: true,
      user: {
        name: result.user.displayName,
        email: result.user.email,
        photo: result.user.photoURL,
        uid: result.user.uid,
      },
    };
  } catch (error) {
    console.error("Error con Facebook Sign In:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

export default app;
